import { useState } from 'react'

import { EMPTY_STRING } from '@flowwai-frontend/shared/constants'

import { validatePinComplexity } from '../utils/PINValidationUtils'

export const useUserPinState = () => {
   const [pin, setPin] = useState(EMPTY_STRING)
   const [pinErrorMessage, setPinErrorMessage] = useState<string | null>(null)
   const [confirmPin, setConfirmPin] = useState(EMPTY_STRING)
   const [confirmPinErrorMessage, setConfirmPinErrorMessage] = useState<
      string | null
   >(null)

   const isPINValid =
      !!pin &&
      pinErrorMessage === null &&
      !!confirmPin &&
      confirmPinErrorMessage === null

   const onChangePin = (value: string) => {
      setPin(value)
      const { errorMessage } = validatePinComplexity(value)
      setPinErrorMessage(errorMessage ?? null)

      onChangeConfirmPin(confirmPin, value)
   }

   const onChangeConfirmPin = (value: string, latestPin?: string) => {
      setConfirmPin(value)

      const pinValue = latestPin ?? pin
      const isPinNotMatched = value && value !== pinValue

      if (isPinNotMatched) {
         setConfirmPinErrorMessage('PINs do not match')
      } else {
         setConfirmPinErrorMessage(null)
      }
   }

   return {
      pin,
      pinErrorMessage,
      confirmPin,
      confirmPinErrorMessage,
      isPINValid,
      onChangePin,
      onChangeConfirmPin
   }
}
